import React from 'react';
import { FiCopy } from 'react-icons/fi';
import Tooltip from './Tooltip';

interface Props {
	onClick?: any;
	tooltip?: string;
	disable?: boolean;
}

function DuplicateButton({ onClick, tooltip, disable }: Props) {
	return (
		<Tooltip tooltipTxt={tooltip || 'Duplicar'}>
			<FiCopy
				className="edit-btn"
				size={20}
				style={{ color: disable ? '#c9cacc' : '#003f79', cursor: disable ? 'default' : 'pointer' }}
				onClick={!disable ? onClick : undefined}
			/>
		</Tooltip>
	);
}

export default DuplicateButton;
